import { render, staticRenderFns } from "./share.vue?vue&type=template&id=6e217d3a&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports